import React, { useState } from "react";
import "../replay-app/DeleteDialog.scss";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { toast } from 'react-toastify';

function VisibilityAllDialog({
  show,
  handleClose,
  onChanged,
  visibility,
  count,
  token
}) {

  const { t } = useTranslation();
  const [inFlight, setInFlight] = useState(false);

    const showError = () => {
        toast.error(t("chanelApp.filters.allError"), {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: 0,
        });
    };

    const changeVisibility = () => {
        if (inFlight) {
            return;
        }
        setInFlight(true);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: "visibility=" + visibility + "&token=" + encodeURIComponent(token)
        };
        fetch(window.serverUrl+`/social/visibility-all.php`, requestOptions)
        .then((r) => r.json())
        .then((resp) => {
            console.log("resp", resp);
            setInFlight(false);
            if (resp.error) {
                console.error("visibility-all refused", resp);
                showError();
                handleClose();
                return;
            }
            onChanged();
        })
        .catch((err) => {
            console.error("fetch problem", err);
            setInFlight(false);
            showError();
            handleClose();
        });

    }

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop
      keyboard={false}
      centered
      dialogClassName="delete-dialog"
    >
        <Modal.Header closeButton closeLabel={false}>
            <Modal.Title>
          {t(visibility === 0 ? "chanelApp.filters.allPrivate" : "chanelApp.filters.allPublic")}
            </Modal.Title>
        </Modal.Header>
          <Modal.Body>
{t(visibility === 0 ? "chanelApp.filters.allPrivateConfirm" : "chanelApp.filters.allPublicConfirm", { count: count })}
{visibility === 1 ? (
  <>
    <br/>
    {t("chanelApp.filters.allPublicWarning")}
  </>
) : <></>}
        </Modal.Body>
        <Modal.Footer>
            <Button onClick={handleClose}>{t("chanelApp.filters.cancel")}</Button>
            <Button className="delete" onClick={changeVisibility} disabled={inFlight}>{t("chanelApp.filters.confirm")}</Button>
        </Modal.Footer>
    </Modal>
  );
}

export default VisibilityAllDialog;
